import { useEffect, useState } from "react";
import {
  Container,
  ContainerContent,
  ContainerItem,
  ContainerSideBar,
  Title,
} from "./localStyle";
import FlechaOption from "_+_Portal/assets/images/generico/FlechaOption";
import { useHistory, useLocation } from "react-router";
import routes from "_+_Portal/routes/listRoutes";
import BuscadorTurnos from "_+_Portal/pages/BuscadorTurnos/BuscadorTurnos";
import { isNativeMobile } from "global/utils/platformDetector";

const OptionSidebar = ({ componentToRender, logoutHome, nextFnc }) => {
  //#region ------ useState ------
  const [selected, setSelected] = useState(null);
  const [itemSelected, setItemSelected] = useState(null);
  //#endregion --- useState ------

  //#region ------ constants ------
  const history = useHistory();
  const url = useLocation().pathname;
  //#endregion ------ constants ------

  //#region --------- funtions ------
  const changeSelected = (index1) => {
    if (Number.isInteger(selected[index1])) {
      setSelected({});
    } else {
      setSelected({ [index1]: 0 });
    }
  };

  const onClick = (item, itemComplete) => {
    if (item === window.location.pathname) return;
    if (item === "*ayuda*") {
      itemComplete.fun();
    } else {
      if (item === "/atencionSinTurno" && isNativeMobile()) {
        sessionStorage.setItem("pasoInicialAutocheckin", "AtencionSinTurnoSelect");
        if (window.location.pathname !== "/autocheckin") {
          history.push("/autocheckin");
        }
        window.dispatchEvent(new CustomEvent("setPasoInicialAutocheckin"));
        if (nextFnc) nextFnc();
        return;
      }
      if (item === "/buscadorTurnos") {
        const index = routes.findIndex((objeto) => objeto.id === 30);
        if (index === -1) {
          routes.push({
            id: 30,
            path: "/buscadorTurnos",
            component: BuscadorTurnos,
            title: "Buscador Turnos",
            needsAuth: false,
          });
        }
      }
      history.push(item);
    }
    if (item === "/") logoutHome();
    if (nextFnc) {
      nextFnc();
    }
  };

  const renderOptionSideBar = (componentToRender) => {
    return componentToRender.titles.map((title, index1) => {
      let titleActive = Number.isInteger(selected[index1]);

      return (
        <Container key={index1}>
          <Title
            key={`container-${index1}`}
            className=""
            $titleActive={
              titleActive &&
              title !== "Ver Recetas" &&
              title !== "Ordenes Médicas" &&
              title !== "Ver Certificados"
            }
            $titleSelected={
              url === componentToRender.contents[index1][0]?.link &&
              (title === "Ver Recetas" || title === "Ordenes Médicas" || title === "Ver Certificados")
            }
            onClick={
              title !== "Ver Recetas" && title !== "Ordenes Médicas" && title !== "Ver Certificados"
                ? () => changeSelected(index1)
                : () => onClick(componentToRender.contents[index1][0]?.link)
            }
          >
            <p className="rb22b">{title}</p>
            {title !== "Ver Recetas" && title !== "Ordenes Médicas" && title !== "Ver Certificados" && (
              <div className="container-arrow">
                <FlechaOption className={"arrow-option"} />
              </div>
            )}
          </Title>
          {title !== "Ver Recetas" && title !== "Ordenes Médicas" && title !== "Ver Certificados" && (
            <ContainerContent $titleActive={titleActive}>
              {componentToRender.contents[index1] &&
                componentToRender.contents[index1].map((content, index2) => {
                  let itemActive = itemSelected[index1] === index2;

                  return (
                    <ContainerItem
                      key={`container-item-${index1}-${index2}`}
                      className="container-item"
                      onClick={() =>
                        onClick(
                          componentToRender.contents[index1][index2].link,
                          componentToRender.contents[index1][index2]
                        )
                      }
                      $itemActive={itemActive}
                    >
                      <div className="iconSidebar">{content.icon}</div>
                      <h1>{content.title}</h1>
                      <div className="flecha-option"></div>
                    </ContainerItem>
                  );
                })}
            </ContainerContent>
          )}
        </Container>
      );
    });
  };
  //#endregion ------ funtions ------

  //#region ------ useEffect ------
  useEffect(() => {
    componentToRender.contents.map((content, index1) => {
      content &&
        content.map((item, index2) => {
          
          // 🔹 Normalizás la URL si viene de "turnoReservado"
          const normalizedUrl =
            url === "/turnoReservado" ? "/proximosTurnos" : url;

          const element = item;
          if (element.link === normalizedUrl) {
            setSelected({ [index1]: index2 });
            setItemSelected({ [index1]: index2 });
          }
        });
    });
  }, []);
  //#endregion ------ useEffect ------

  return (
    <ContainerSideBar>
      {selected !== null &&
        itemSelected !== null &&
        renderOptionSideBar(componentToRender)}
    </ContainerSideBar>
  );
};

export default OptionSidebar;
